import BehaviorActionTypes from '../../constants/behavior_action_types';

import EnumValidator from 'validator/enum_validator';

export default class BehaviorAction {
	_type;

	constructor(props = {}) {
		Object.keys(props)
			.forEach((propName) => this[propName] = props[propName]);
	}

	get type() {
		return this._type;
	}

	set type(value) {
		EnumValidator.validate(value, BehaviorActionTypes);
		this._type = BehaviorActionTypes[value];
	}
}
